import { FetchState, AuthorizedSignerState } from "@/shared/types";
import * as bankService from "@/shared/api/bankService";
import * as storeHelper from "@/shared/storeHelper";
import * as _ from "lodash";
import { defineStore } from "pinia";

export const initialState: AuthorizedSignerState = {
  fetchState: FetchState.Uninitialized,
  authorizedSigners: {},
  canOrderDebitCard: false,
  debitCardEligibilityFetchState: FetchState.Uninitialized
};

export const useAuthorizedSignerStore = defineStore("authorizedSigner", {
  state: (): AuthorizedSignerState => (_.cloneDeep(initialState)),
  getters: {
    isLoaded: state => state.fetchState === FetchState.Loaded,
    isLoading: state => state.fetchState === FetchState.Loading
  },
  actions: {
    loadAuthorizedSigners (args: { username: string, partnerId: number }) {
      this.authorizedSigners = {};
      this.fetchState = FetchState.Loading;

      bankService.getAuthorizedSigners(args)
        .then(response => {
          this.fetchState = FetchState.Loaded;
          this.authorizedSigners = response.data.authorizedSigners.reduce((result, current) => {
            result[current.id] = current;
            return result;
          }, {});
        })
        .catch(error => {
          this.authorizedSigners = {};
          this.fetchState = FetchState.Failed;
          return storeHelper.handleError({ error, rethrow: false });
        });
    }
  }
});
